import { planningDay, type PlanningMomentType, type PlanningStatus } from "@klantpunt/shared";
import { IconCheck, IconClose, IconPlanning } from "../../app/icons";

const TEXT: Record<PlanningMomentType, string> = {
  done: "Uitgevoerd",
  due: "Vervalt",
  forecast: "Prognose",
  planned: "Gepland",
};

/**
 * Teken in de planning: ✓ uitgevoerd (groen), ✕ volgende keer (rood als verlopen, amber als te plannen) en
 * een licht ✕ voor de prognose; een agenda-icoon voor een afspraak (agenda op de telefoon). De tekst staat in `aria-label` en `title`; kleur is nooit de enige drager.
 */
export function PlanningMark({
  type,
  status,
  dates,
}: {
  type: PlanningMomentType;
  status: PlanningStatus;
  dates: string[];
}) {
  const label = `${TEXT[type]} ${dates.map(planningDay).join(", ")}`;
  const Icon = type === "done" ? IconCheck : type === "planned" ? IconPlanning : IconClose;
  // Zonder datum (legenda): alleen het teken, de tekst staat ernaast.
  const a11y = dates.length ? { role: "img", "aria-label": label, title: label } : { "aria-hidden": true };
  return (
    <span className={`kp-mark kp-${type} kp-st-${status}`} {...a11y}>
      <Icon size={16} strokeWidth={2.5} aria-hidden="true" />
    </span>
  );
}

/** Stip met de status van de regel (met tekst voor schermlezers). */
export const STATUS_DOT: Record<PlanningStatus, string> = {
  verlopen: "ob-overdue",
  na_vervaldatum: "ob-overdue",
  te_plannen: "ob-soon",
  gepland: "ob-ok",
  later: "ob-ok",
  onbekend: "ob-unknown",
  klaar: "ob-ok",
};
